// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-toolbar--mini-padding-top[data-v-0c419291]{margin-top:1px}[dir=ltr] .header__fraud[data-v-0c419291]{text-align:right}[dir=rtl] .header__fraud[data-v-0c419291]{text-align:left}.header__fraud__line-1[data-v-0c419291]{font-size:16px}.header__fraud__line-2[data-v-0c419291]{font-size:13px}.max-height-95vh[data-v-0c419291]{max-height:95vh}.header__tabs[data-v-0c419291]{width:auto}", ""]);
// Exports
module.exports = exports;
